module.exports = __webpack_public_path__ + "static/media/appointment_declined.ae14bab4.svg";